import tw from "twin.macro"

import styled, { css } from "styled-components/macro"

const gradientStyle = css`
  ${tw`text-center w-full bg-gradient-to-r from-gradient-alternate-pink-medium to-gradient-alternate-purple-medium text-white rounded-lg px-7 py-3 font-medium flex items-center transition-all focus:outline-none relative overflow-hidden z-10`}

  &::before, &::after {
    ${tw`block absolute top-0 left-0 w-full h-full bg-gradient-to-r opacity-0 transition-opacity`}
    content: "";
    z-index: -1;
  }

  &::before {
    ${tw`from-gradient-alternate-pink-heavy to-gradient-alternate-purple-heavy`}
  }

  &::after {
    ${tw`from-gradient-alternate-pink-dark to-gradient-alternate-purple-dark`}
  }

  &:hover:not(:disabled) {
    ${tw`shadow-md`}

    &::before {
      ${tw`opacity-100`}
    }
  }

  &:focus:enabled,
  &:active:enabled {
    &::after {
      ${tw`opacity-100`}
    }
  }

  &:disabled {
    ${tw`opacity-50 cursor-auto`}
  }
`

export const GradientButton = styled.button`
  ${gradientStyle}
`

export const GradientA = styled.a`
  ${gradientStyle};

  text-decoration: none;
`

export const GradientDiv = styled.div`
  ${gradientStyle};
`

export default GradientButton
